import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Install = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Install' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M19,13.5 L19,17.5 L12,22 L5,17.5 L5,13.5 M12,22 L12,13.5 M18.5,8.5 L12,4.5 L15.5,2 L22,6 L18.5,8.5 L18.5,8.5 L18.5,8.5 Z M5.5,8.5 L12,4.5 L8.5,2 L2,6 L5.5,8.5 L5.5,8.5 L5.5,8.5 Z M18.5,9 L12,13 L15.5,15.5 L22,11.5 L18.5,9 L18.5,9 L18.5,9 Z M5.5,9 L12,13 L8.5,15.5 L2,11.5 L5.5,9 L5.5,9 Z' />
  </StyledIcon>
);
